<template>
  <v-dialog persistent :value="value" @input="$emit('input', $event)" max-width="400">
    <app-base
      :qualification="qualification"
      @close="$emit('input', false)"
      @new-qual="$emit('new-qual', $event)"
    />
  </v-dialog>
</template>
<script>
import Base from "./QuaBase.vue";
export default {
  components: {
    appBase: Base,
  },
  props: {
    value: {
      required: false,
    },
    qualification: {
      required: true,
    },
  },
};
</script>
